import { Component, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DialogBase, DialogCloseReason } from '../dialogs/base-dialog';
import { WebPageContentApi, IWebPageOpenGraphData } from './web-page-content.api';
import { ErrorHandlingService } from '../http/error-handling.service';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'fetch-web-page-content-dialog',
  templateUrl: 'fetch-web-page-content-dialog.html',
  animations: [
    trigger('errorAnimation', [
      state('inactive', style({ opacity: 0 })),
      state('active', style({ opacity: 1 })),
      transition('inactive <=> active', animate('500ms'))
    ])
  ],
})
export class FetchWebPageContentDialogComponent extends DialogBase {
  readonly fieldDefaultValue = '--';
  public lastValidationError: string;
  public errorState: string;
  public fetchingData = false;
  private validationErrorLabelTimeout: number;
  
  @Input() webPageUrl: string;

  constructor(
    private webPageContentApi: WebPageContentApi,
    public translate: TranslateService,
    public errorHandlingService: ErrorHandlingService
  ) {
    super();
  }

  public initDialog(): void {
    this.validationErrorLabelTimeout = 10000;
    this.lastValidationError = 'error placeholder'; // This is needed for better animation.
    this.errorState = 'inactive';
    this.webPageUrl = this.fieldDefaultValue;
  }

  public getTypeClass(): string {
    return 'input';
  }

  public onLinkChanged = (): void => {
    this.errorState = 'inactive';
  }

  private showValidationError = (): void => {
    this.errorState = 'active';
  }

  public submitForm = (value: unknown): void => this.onOk();

  public onOk = (): void => {
    this.lastValidationError = null;
    this.errorState = 'inactive';
    this.fetchingData = true;
    this.webPageContentApi.getWebPageContentData(this.webPageUrl)
      .pipe(finalize(() => this.fetchingData = false))
      .subscribe(
        (webPageContentData: IWebPageOpenGraphData) => {
          if (!webPageContentData.Title && !webPageContentData.Description) {
            this.lastValidationError = this.translate.instant('COMMON.DIALOGS.FETCH_WEB_PAGE_CONTENT.ERRORS.NO_DATA_ON_PAGE');
            this.showValidationError();
          } else {
            this.close({ reason: DialogCloseReason.OK, data: {webPageContentData} });
          }
        },
        () => {
          this.lastValidationError = this.translate.instant('COMMON.DIALOGS.FETCH_WEB_PAGE_CONTENT.ERRORS.INVALID_URL');
          this.showValidationError();
        }
      );
  }

  cancel = (): void => this.close({ reason: DialogCloseReason.CANCEL });

}
